<template>
  <div class="tags-view-container">
    <!-- 借用 el-tabs 仅作为标签栏 UI; 每个 tab-pane 内容区为空 (用 CSS display:none 隐藏).
         closable 由每个 tab-pane 自己决定 (affix=true 的 tab 不可关闭). -->
    <el-tabs
      v-model="activeTagProxy"
      type="card"
      @tab-click="onTabClick"
      @tab-remove="closeSelectedTag"
    >
      <el-tab-pane
        v-for="tag in visitedViews"
        :key="tag.path"
        :name="tag.path"
        :closable="!isAffix(tag)"
      >
        <span slot="label" @contextmenu.prevent="openMenu(tag, $event)">
          {{ tag.title }}
        </span>
      </el-tab-pane>
    </el-tabs>

    <ul v-show="visible" :style="{left: left + 'px', top: top + 'px'}" class="contextmenu">
      <li @click="refreshSelectedTag(selectedTag)">{{ $tApp('tags.refresh') }}</li>
      <li v-if="!isAffix(selectedTag)" @click="closeSelectedTag(selectedTag.path)">{{ $tApp('tags.close') }}</li>
      <li @click="closeOthersTags">{{ $tApp('tags.closeOthers') }}</li>
      <li @click="closeAllTags">{{ $tApp('tags.closeAll') }}</li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'TagsView',
  data() {
    return {
      visible: false,
      top: 0,
      left: 0,
      selectedTag: null
    }
  },
  computed: {
    visitedViews() {
      return this.$store.state.tagsView.visitedViews
    },
    activeTag() {
      return this.$route.path
    },
    activeTagProxy: {
      get() {
        return this.$route.path
      },
      set() {}
    }
  },
  watch: {
    $route() {
      this.addTags()
      this.moveToCurrentTag()
    },
    visible(value) {
      if (value) {
        document.body.addEventListener('click', this.closeMenu)
      } else {
        document.body.removeEventListener('click', this.closeMenu)
      }
    }
  },
  mounted() {
    this.initTags()
    this.addTags()
  },
  methods: {
    isAffix(tag) {
      return tag && tag.meta && tag.meta.affix
    },
    initTags() {
      const affixTags = [{
        path: '/home',
        fullPath: '/home',
        name: 'home',
        meta: { title: '仪表盘', affix: true },
        title: this.$tApp('tags.dashboard')
      }]
      for (const tag of affixTags) {
        this.$store.dispatch('addVisitedView', tag)
      }
    },
    addTags() {
      const { name } = this.$route
      if (name) {
        this.$store.dispatch('addView', this.$route)
      }
    },
    moveToCurrentTag() {
      if (this.$route.path === '/') {
        this.$router.replace('/home').catch(() => {})
      }
    },
    onTabClick(tab) {
      if (tab && tab.name && tab.name !== this.$route.path) {
        this.$router.push(tab.name).catch(() => {})
      }
    },
    refreshSelectedTag(view) {
      const target = view || this.$route
      this.$router.replace({
        path: target.path,
        query: Object.assign({}, target.query, { _t: Date.now() })
      }).catch(() => {})
    },
    closeSelectedTag(path) {
      const view = this.visitedViews.find(v => v.path === path)
      if (!view) return
      this.$store.dispatch('delView', view).then(({ visitedViews }) => {
        if (this.isActive(view)) {
          this.toLastView(visitedViews, view)
        }
      })
    },
    closeOthersTags() {
      this.$store.dispatch('delOthersViews', this.$route).then(() => {
        this.visible = false
      })
    },
    closeAllTags() {
      this.$store.dispatch('delAllViews').then(({ visitedViews }) => {
        this.toLastView(visitedViews, this.$route)
      })
    },
    toLastView(visitedViews) {
      const latestView = visitedViews.slice(-1)[0]
      if (latestView) {
        this.$router.push(latestView.path).catch(() => {})
      } else {
        this.$router.push('/home').catch(() => {})
      }
    },
    isActive(route) {
      return route.path === this.$route.path
    },
    openMenu(tag, e) {
      const menuMinWidth = 105
      const offsetLeft = this.$el.getBoundingClientRect().left
      const offsetWidth = this.$el.offsetWidth
      const maxLeft = offsetWidth - menuMinWidth
      const left = e.clientX - offsetLeft + 15
      if (left > maxLeft) {
        this.left = maxLeft
      } else {
        this.left = left
      }
      this.top = e.clientY
      this.visible = true
      this.selectedTag = tag
    },
    closeMenu() {
      this.visible = false
    }
  }
}
</script>

<style lang="scss">
.tags-view-container {
  background: var(--bg-surface);
  border-bottom: 1px solid var(--border-color);
  padding: 8px 12px 4px;
  position: sticky;
  top: var(--nav-height, 50px);
  z-index: 1102;
  overflow: visible;
}

/* el-tabs 的 .el-tabs__nav 是 float:left，而本组件把 nav-wrap/nav-scroll 改成了
   overflow:visible（为避免标签圆角/激活态被裁），导致该浮动"逃逸"出标签栏，
   下方页面的第一个块级元素（如筛选卡）会贴着这条浮动右侧排版、随标签变多越挤越小。
   这里用 clearfix 把浮动收回标签栏内部，杜绝逃逸。(2026-06-01 修) */
.tags-view-container::after {
  content: "";
  display: block;
  clear: both;
}

.tags-view-container .el-tabs,
.tags-view-container .el-tabs__header,
.tags-view-container .el-tabs__nav-wrap,
.tags-view-container .el-tabs__nav-scroll {
  overflow: visible;
}

.tags-view-container .el-tabs__header {
  margin: 0;
}
.tags-view-container .el-tabs__nav-wrap::after {
  height: 0;
}
/* 我们只用 el-tabs 当标签栏, 每个 tab-pane 不渲染内容; 隐藏 el-tabs 自己的内容区
   避免它撑出多余的空白高度. 实际页面内容由 <router-view> 在 AppMain 里渲染. */
.tags-view-container .el-tabs__content {
  display: none;
}
.tags-view-container .el-tabs__item {
  border-radius: 8px;
  height: 32px;
  line-height: 32px;
  padding: 0 14px !important;
  margin-right: 6px;
  color: var(--text-secondary);
  font-weight: 500;
  border: 1px solid transparent;
  transition: color 0.15s ease, background 0.15s ease, border-color 0.15s ease;
}
.tags-view-container .el-tabs__item:hover {
  color: var(--text-primary);
  background: rgba(148, 163, 184, 0.1);
}
.tags-view-container .el-tabs__item.is-active {
  color: #2563eb;
  font-weight: 600;
  background: rgba(37, 99, 235, 0.08);
  border-color: rgba(37, 99, 235, 0.25);
}

body.theme-dark .tags-view-container .el-tabs__item:hover {
  background: rgba(148, 163, 184, 0.08);
}
body.theme-dark .tags-view-container .el-tabs__item.is-active {
  background: rgba(37, 99, 235, 0.15);
  border-color: rgba(96, 165, 250, 0.35);
}

.contextmenu {
  margin: 0;
  background: var(--bg-surface);
  z-index: 3000;
  position: fixed;
  list-style-type: none;
  padding: 6px 0;
  border-radius: 10px;
  border: 1px solid var(--border-color);
  font-size: 13px;
  font-weight: 500;
  color: var(--text-primary);
  box-shadow: var(--shadow-dropdown, 0 12px 32px rgba(15, 23, 42, 0.12));
  li {
    margin: 0;
    padding: 8px 18px;
    cursor: pointer;
    &:hover {
      background: rgba(37, 99, 235, 0.08);
      color: #2563eb;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/layout/components/TagsView.vue